<template>
  <div class="spinner-circle">
    <div class="spinner-circle1 spinner-child"></div>
    <div class="spinner-circle2 spinner-child"></div>
    <div class="spinner-circle3 spinner-child"></div>
    <div class="spinner-circle4 spinner-child"></div>
    <div class="spinner-circle5 spinner-child"></div>
    <div class="spinner-circle6 spinner-child"></div>
    <div class="spinner-circle7 spinner-child"></div>
    <div class="spinner-circle8 spinner-child"></div>
    <div class="spinner-circle9 spinner-child"></div>
    <div class="spinner-circle10 spinner-child"></div>
    <div class="spinner-circle11 spinner-child"></div>
    <div class="spinner-circle12 spinner-child"></div>
  </div>
</template>

<script>
  export default {
    name: 'x-spinner'
  }
</script>

<style lang='scss' rel='stylesheet/scss'>
  // Spinner from SpinKit
  .spinner-circle {
    width: 4rem;
    height: 4rem;
    position: relative;
  }
  .spinner-circle .spinner-child {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }
  .spinner-circle .spinner-child:before {
    content: '';
    display: block;
    margin: 0 auto;
    width: 15%;
    height: 15%;
    background-color: white;
    border-radius: 100%;
    animation: spinner-circleBounceDelay 1.2s infinite ease-in-out both;
  }
  .spinner-circle .spinner-circle2 {
    transform: rotate(30deg);
  }
  .spinner-circle .spinner-circle3 {
    transform: rotate(60deg);
  }
  .spinner-circle .spinner-circle4 {
    transform: rotate(90deg);
  }
  .spinner-circle .spinner-circle5 {
    transform: rotate(120deg);
  }
  .spinner-circle .spinner-circle6 {
    transform: rotate(150deg);
  }
  .spinner-circle .spinner-circle7 {
    transform: rotate(180deg);
  }
  .spinner-circle .spinner-circle8 {
    transform: rotate(210deg);
  }
  .spinner-circle .spinner-circle9 {
    transform: rotate(240deg);
  }
  .spinner-circle .spinner-circle10 {
    transform: rotate(270deg);
  }
  .spinner-circle .spinner-circle11 {
    transform: rotate(300deg);
  }
  .spinner-circle .spinner-circle12 {
    transform: rotate(330deg);
  }
  .spinner-circle .spinner-circle2:before {
    animation-delay: -1.1s;
  }
  .spinner-circle .spinner-circle3:before {
    animation-delay: -1s;
  }
  .spinner-circle .spinner-circle4:before {
    animation-delay: -0.9s;
  }
  .spinner-circle .spinner-circle5:before {
    animation-delay: -0.8s;
  }
  .spinner-circle .spinner-circle6:before {
    animation-delay: -0.7s;
  }
  .spinner-circle .spinner-circle7:before {
    animation-delay: -0.6s;
  }
  .spinner-circle .spinner-circle8:before {
    animation-delay: -0.5s;
  }
  .spinner-circle .spinner-circle9:before {
    animation-delay: -0.4s;
  }
  .spinner-circle .spinner-circle10:before {
    animation-delay: -0.3s;
  }
  .spinner-circle .spinner-circle11:before {
    animation-delay: -0.2s;
  }
  .spinner-circle .spinner-circle12:before {
    animation-delay: -0.1s;
  }

  @keyframes spinner-circleBounceDelay {
    0%, 80%, 100% {
      transform: scale(0);
    }

    40% {
      transform: scale(1);
    }
  }
</style>
